exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Enter and leave animations can use different */\n\n/* durations and timing functions.              */\n.slide-fade-enter-active, .slide-main-enter-active {\n  transition: all .3s ease;\n}\n.slide-fade-leave-active, .slide-main-leave-active {\n  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);\n}\n.slide-fade-enter, .slide-fade-leave-to\n/* .slide-fade-leave-active below version 2.1.8 */ {\n  transform: translateY(-15px);\n  opacity: 0;\n}\n.slide-main-enter, .slide-main-leave-to\n/* .slide-fade-leave-active below version 2.1.8 */ {\n  transform: translateY(15px);\n  opacity: 0;\n}\n", ""]);

// exports
